import React from 'react';
import BaseComponent from "../BaseComponent";
import InputText from "../../../appl/view/components/inputFields/InputText";
import DialogBase from "./DialogBase";
import PropTypes from "prop-types";
import HorizontalLayout from "../layouts/HorizontalLayout";
import CM from "../../../appl/model/system/CM";
import Checkbox from "../checkbox/Checkbox";
import shortid from "shortid";
import CloneCampaign from "../../../appl/model/service/campaign/dto/CloneCampaign";
import VerticalLayout from "../layouts/VerticalLayout";
import {toast} from "react-toastify";
import InputSearchDropDown from "../../../appl/view/components/inputFields/dropdown/InputSearchDropDown";
import GF from "../../utils/GF";
import T from "../../../appl/model/system/text_translations/Translator";
import Button from "../../../appl/view/components/buttons/Button";
import LoadingButton from "@mui/lab/LoadingButton";
import CampaignService from "../../../appl/model/service/campaign/CampaignService";

class DialogCloneCampaign extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedDomain: null,
      selectedTables: [],
      selectedTableOptions: [],
      selectedVariants: [],
      newCampaignName: null,
      campaignDescription: null,
      privilege: {id: '0', label: 'Default'},
      description: '',
      isLoading: false,
    }

    this.domains = this.props.data.domains.records.map((domain) => {
      let id = domain['po2\\system\\db\\doctrine\\entity\\SysDomain#id'];
      let name = domain['po2\\system\\db\\doctrine\\entity\\SysDomain#name'];
      let item = {id: id, label: name};

      if (this.props && this.props.data && this.props.data.campaign && typeof this.props.data.campaign === 'object' &&
        this.props.data.campaign.hasOwnProperty('domainId') && this.props.data.campaign.domainId === id) {

        this.state.selectedDomain = item;
      }
      return item;
    });
    if (this.state.selectedDomain === null && this.domains.length > 0) {
      this.state.selectedDomain = this.domains[0];
    }

    let result = this.createTableCheckboxes();
    this.tables = result.tables;
    this.tablesOptions = result.tableOptions;
    this.variables = this.createVariablesCheckboxes();
  }

  createVariablesCheckboxes() {
    return this.props.data.variables.map((variant, index) => {
      return <Checkbox widthFit={true} _id={index} onChange={(e, id, checked) => {
        if (checked) {
          for (let variantIndex in this.state.selectedVariants) {
            let value = this.state.selectedVariants[variantIndex];
            if (value === this.props.data.variables[id]) {
              this.state.selectedVariants = GF.removeFromArray(this.state.selectedVariants, variantIndex);
              break;
            }
          }
        } else {
          this.state.selectedVariants.push(this.props.data.variables[id]);
        }
      }} checked key={shortid()} labelElement={variant}/>
    });
  }

  createTableCheckboxes() {
    let elements = [];
    elements = this.props.data.tables.campaignTables.map((table, index) => {
      this.state.selectedTables.push(table.name);

      let tempRetVal = {};
      tempRetVal['tableCheckBoxe'] = <Checkbox widthFit={true} _id={table.name} onChange={(e, id, checked) => {
        this.private_checkUncheckOption(checked, id, this.state.selectedTables);
      }} checked key={shortid()} labelElement={table.label}/>;

      if (table.name === 'appl\\module\\modules\\contactModule\\v001\\model\\entity\\Contact') {
        tempRetVal['tableOptionCheckBoxe'] = <Checkbox widthFit={true} _id={table.name} onChange={(e, id, checked) => {
          this.private_checkUncheckOption(checked, id, this.state.selectedTableOptions);
        }} key={shortid()} labelElement={'Status zurücksetzen (' + table.label + ')'}/>;
      } else {
        tempRetVal['tableOptionCheckBoxe'] = <></>;
      }
      return tempRetVal;
    });

    let retVal = {tables: [], tableOptions: []};
    for (let i = 0; i < elements.length; i++) {
      let element = elements[i];
      retVal.tables.push(element.tableCheckBoxe);
      retVal.tableOptions.push(element.tableOptionCheckBoxe);
    }
    return retVal;
  }

  private_checkUncheckOption(checked, id, object) {
    if (checked) {
      if (!object.includes(id)) {
        object.push(id);
      }
    } else {
      let index = object.indexOf(id);
      if (index !== -1) {
        object.splice(index, 1);
      }
    }
  }

  onCloneButtonClick(e) {
    this.setState({isLoading: true});
    let cloneCampaign = new CloneCampaign(this.props.campaignId, this.state.newCampaignName,
      this.state.campaignDescription, this.state.selectedDomain.id, this.state.privilege.id,
      this.state.selectedVariants, this.state.selectedTables, this.state.selectedTableOptions);

    CM.get().doJsonAjax(CM.get().getServiceUrl(CampaignService.NAME), cloneCampaign, (response) => {
      this.setState({isLoading: false});
      if (response.success) {
        toast.success('Campaign wurde erfolgreich geklont.');
        if (this.props.onCloneButtonClick) {
          this.props.onCloneButtonClick(e);
        }
      } else {
        toast.error(response.message);
      }
    });
  }

  render() {
    let sortedDomains = this.domains.sort((a, b) => a.label.localeCompare(b.label, 'de', {sensitivity: 'base'}));

    return <DialogBase
      open={true}
      onCloseButtonClick={this.props.onCloseButtonClick}
      scroll='paper'
      maxWidth='md'
      title='Campaign Klonen'
      actions={<>
        <Button
          color=''
          disabled={this.state.isLoading}
          onClick={this.props.onCloseButtonClick}
          variant='outlined'>
          {T.label_cancel()}
        </Button>
        <LoadingButton
          variant='contained'
          loading={this.state.isLoading}
          onClick={(e) => this.onCloneButtonClick(e)}
          color='primary'>
          {T.label_clone()}
        </LoadingButton>
      </>}>
      <div className='grid grid-cols-12 gap-4'>
        <VerticalLayout className='col-span-full md:col-span-4 gap-4'>
          <InputText maxLength={28} labelElement='Name' onChange={(e) => this.state.newCampaignName = e.target.value}/>
          <InputSearchDropDown key={shortid()} inputLayout='inline' labelElement='Domain'
                               defaultValue={this.state.selectedDomain}
                               onChange={(e, id, data) => this.state.selectedDomain = data}
                               disableClearable={true}>
            {sortedDomains}
          </InputSearchDropDown>

          <InputSearchDropDown labelElement='Berechtigung' defaultValue={this.state.privilege}
                               onChange={(e, id, data) => this.state.privilege = data}
                               disableClearable={true}>
            {[{id: '0', label: 'Default'}, {id: '1', label: 'Alle Benutzers'}, {id: '2', label: 'Nur ich'}]}
          </InputSearchDropDown>

        </VerticalLayout>
        <VerticalLayout className='col-span-full md:col-span-8'>
          <InputText multiline={true} onChange={(e, id,
                                                 data) => this.state.campaignDescription = data} minRows={7} labelElement='Beschreibung'/>
        </VerticalLayout>
      </div>

      <h3 className='mt-5'>{T.label_tables()}</h3>
      <HorizontalLayout className='items-center gap-1 flex-wrap'>
        {this.tables}
      </HorizontalLayout>
      <h3 className='mt-5'>Tabellen-Optionen</h3>
      <HorizontalLayout className='items-center gap-1 flex-wrap'>
        {this.tablesOptions}
      </HorizontalLayout>
      <h3 className='mt-5'>Variablen</h3>
      <HorizontalLayout className='items-center gap-x-1 flex-wrap'>
        {this.variables}
      </HorizontalLayout>
    </DialogBase>;
  }
}

DialogCloneCampaign.propTypes = {
  title: PropTypes.string,
  closable: PropTypes.bool,
  opened: PropTypes.bool,
  onCloseButtonClick: PropTypes.func,
  onCloneButtonClick: PropTypes.func,
  data: PropTypes.object
}
export default DialogCloneCampaign;